import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionText } from '../../../components/SectionText'
import { TableContent, TableRow } from '../../../components/TableRow'

interface Section2Props {
    classname?: string
}

export const CvAndQualification: React.FC<Section2Props> = ({ classname }) => {
    const { t } = useTranslation()

    const rowData = t('cvAndQualifications.cv', { returnObjects: true }) as Array<{ year: string; description: string }>
    const qualifications = t('cvAndQualifications.qualifications.items', { returnObjects: true }) as string[]

    const rowStyles = (index: number) => {
        return {
            classNameTr: index === 10 ? 'w-full' : 'border-b w-full',
            classNameTdLeft: index === 0 ? 'font-bold w-[150px] pr-20 pt-5' : 'font-bold',
            classNameTdRight: index === 0 ? 'pt-5' : '',
        }
    }

    const rowProps: TableContent[] = rowData.map((row, index) => ({
        ...rowStyles(index),
        textColumnLeft: row.year,
        textColumnRight: <div>{row.description}</div>,
    }))
    return (
        <div
            className={`${classname} flex flex-col items-center justify-center min-h-[800px] w-full bg-white py-5
            sm:h-auto sm:px-5
        `}>
            <SectionText
                className="place-content-center w-1/2 h-full text-primary-green justify-center pt-10 sm:w-full"
                title="Curriculum Vitae"
                hrLineColor="bg-primary-green"
                hrLineClassName="w-full">
                <table className="w-full">
                    {rowProps.map((value, index) => {
                        return <TableRow key={index} TableRowProps={value} />
                    })}
                </table>
            </SectionText>

            <SectionText
                className="mt-24 pb-10 w-1/2 min-h-[300px] text-primary-green sm:w-full sm:px-3"
                title={t('cvAndQualifications.qualifications.title')}
                hrLineColor="bg-primary-green">
                <div>
                    <ul className="list-disc pl-5">
                        {qualifications.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </SectionText>
        </div>
    )
}
